import '../../../../../../../util/styles/index.js';
import { mergeProps } from '@react-aria/utils';
import { useFormFieldContext } from '../../../../FormField/hooks/useFormFieldContext.js';
import { useAdsStyles } from '../../../../../../../util/styles/hooks/useAdsStyles.js';

var useSelectNative = function useSelectNative() {
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId,
    isDisabled = _useFormFieldContext.isDisabled;
  var selectStyle = mapAdsStyles({
    width: '100%',
    outlineStyle: 'none',
    borderStyle: 'none',
    px: '0',
    minHeight: 'inherit',
    textVariant: 'body-default',
    backgroundColor: 'base.surface',
    appearance: 'none'
  });
  return {
    isDisabled: isDisabled,
    selectProps: mergeProps(selectStyle, {
      'aria-labelledby': labelId
    })
  };
};

export { useSelectNative };
//# sourceMappingURL=useSelectNative.js.map
